const loginBtn = document.querySelectorAll(".SSO_popup_login"); // simple login
const registerBtn = document.querySelectorAll(".SSO_popup_register"); // cc register
const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber

const popup = document.getElementById("new_popup-modal2");
const close_popup = document.querySelector("#new_popup-modal2 .close_popup");
const overlay = document.getElementById("new_popup-overlay2");

const mainLoginForm = document.querySelector(".main_login_form");
const mainSignupForm = document.querySelector(".main_signup_form");
const mainSignupEliteForm = document.querySelector(".main_elite_signup_form");
const mainEliteUpgradeForm = document.querySelector(".main_elite_upgrade_form");

const renewMembershipPopup = document.querySelector('.subscribe_elite_membershop');
const campaignRenewMembershipPopup = document.querySelector('.campaign_elite_membership');

if (!localStorage.getItem("popupClosed")) {
  setTimeout(() => {
    if (localStorage.getItem("popupClosed") != "true") {
      openPopup2("signup_form");
    }
  }, 3000);
}

const closePopup2 = function (firstTime = false) {
  popup.style.display = "none";
  overlay.style.display = "none";

  if (firstTime) localStorage.setItem("popupClosed", "true");
};

openPopup2 = function (form) {
  if (form == "login_form") {
    document
      .querySelectorAll(".new_forms")
      .forEach((f) => f.classList.add("new_hidden"));
    mainLoginForm.classList.remove("new_hidden");
  } else if (form == "signup_form") {
    document
      .querySelectorAll(".new_forms")
      .forEach((f) => f.classList.add("new_hidden"));
    mainSignupForm.classList.remove("new_hidden");
  } else if (form == "signup_elite_form") {
    document
      .querySelectorAll(".new_forms")
      .forEach((f) => f.classList.add("new_hidden"));
    mainSignupEliteForm.classList.remove("new_hidden");
  } else if (form == "signup_upgrade_form") {
    document
      .querySelectorAll(".new_forms")
      .forEach((f) => f.classList.add("new_hidden"));
    mainEliteUpgradeForm.classList.remove("new_hidden");
  }

  popup.style.display = "block";
  overlay.style.display = "block";
};

overlay.addEventListener("click", function () {
  if (
    !localStorage.getItem("popupClosed") ||
    localStorage.getItem("popupClosed") != "true"
  ) {
    closePopup2(true);
  } else {
    closePopup2();
  }
});
close_popup.addEventListener("click", function () {
  if (
    !localStorage.getItem("popupClosed") ||
    localStorage.getItem("popupClosed") != "true"
  ) {
    closePopup2(true);
  } else {
    closePopup2();
  }
});

loginBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    openPopup2("login_form");
  });
});

registerBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    openPopup2("signup_form");
  });
});

eliteJoinBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    openPopup2("signup_elite_form");
  });
});

eliteUpgradeBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    openPopup2("signup_upgrade_form");
  });
});
openResubscribeMembership = function () {
  const renew_popup_opened = localStorage.getItem("renew_popup_open_once");
  console.log(renew_popup_opened);
  if(!renew_popup_opened) {
    const days_expires = localStorage.getItem("membership_expiring_in_days");
    renewMembershipPopup.querySelector(".expires_days").textContent = days_expires;
    mainLoginForm.classList.add('new_hidden');
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    localStorage.setItem("renew_popup_open_once", true)
    lockPageScroll();
  }
}

checkIfMembershipExpiring = function(date) {
const expiryDate = new Date(date);

localStorage.setItem("membership_expiry_date", expiryDate.toISOString());

const savedExpiry = localStorage.getItem("membership_expiry_date");

  if (savedExpiry) {
    const expiry = new Date(savedExpiry);
    const today = new Date();
    
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const membershipExpiringSoon = diffDays <= 30;

    localStorage.setItem("membership_expiring_soon", membershipExpiringSoon);
    localStorage.setItem("membership_expiring_in_days", diffDays);

    console.log(`Membership expires in ${diffDays} days`);
    console.log("Expiring soon:", membershipExpiringSoon);
  }
}

async function handleMembershipRenewals() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMembershipRenew = urlParams.get('membership_renew') === 'true';

  if (isMembershipRenew && !window.isCustomerLoggedIn) {
    campaignRenewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }
  if (isMembershipRenew && window.isCustomerLoggedIn) {
    renewMembershipPopup.classList.remove('new_hidden');
    popup.style.display = 'block';
    overlay.style.display = 'block';
    mainLoginForm.classList.add('new_hidden');
  }

  // const isMembershipRenewDirect = urlParams.get('membership_renew_direct') === 'true';

  // if (isMembershipRenewDirect) {
  //   try {
  //     await addEliteProductToCart();
  //     window.location.href = "/checkout";
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // }
}
if(window.enableRenew) { 
  handleMembershipRenewals();
}

document.addEventListener('DOMContentLoaded', function () {
  const campaignRenewBtn = document.querySelector('.login_to_renew');
  
  if (campaignRenewBtn) {
    campaignRenewBtn.addEventListener('click', function () {
      campaignRenewMembershipPopup?.classList.add('new_hidden');
      mainLoginForm?.classList.remove('new_hidden');
      popup.style.display = 'block';
      overlay.style.display = 'block';
    });
  }
});

// const EVENT_ACTIONS = {
//     CLOSE_WINDOW: "CLOSE_WINDOW",
//     REDIRECT_SUCCESS: "REDIRECT_SUCCESS",
//     ELITE_REGISTER_SUCCESS: "ELITE_REGISTER_SUCCESS",
//     ELITE_UPGRADE: "ELITE_UPGRADE",
//   };

//   const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
//   const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
//   const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
//   const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber

//   loginBtn.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       openSSOPopup("login");
//     });
//   });

//   registerBtn.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       openSSOPopup("signup");
//     });
//   });

//   eliteJoinBtn.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       openSSOPopup("elite/join");
//     });
//   });

//   eliteUpgradeBtn.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       openSSOPopup("elite/upgrade");
//     });
//   });

//   const SSU_URL = "https://sso.cabanaclubusa.com";
//   function getCLient() {
//     return "8BIQjZ2ndoq9hiYWyuStzg%3D%3D%3Aa72Sm12UMedOmAdyhVdGysjMlvRzd1thIPkXFnQbBoqqsvr48OTvPIEe1%2BUt46zoa5mUTZUzCpoftzmGtx2qLQ%3D%3D";
//   }

//   async function addEliteProductToCart() {
//     const id = "40997247189072";

//     const get_cart = await getCart();
//     const matched_item = get_cart.items.find((item) => item.variant_id == id);

//     if (matched_item) {
//       const updates = { [id]: 1 };

//       try {
//         const response = await fetch(
//           window.Shopify.routes.root + "cart/update.js",
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ updates }),
//           }
//         );

//         if (!response.ok) throw new Error("Failed to remove item from cart");

//         const data = await response.json();
//         console.log("Item removed from cart:", data);
//         alert("Elite Membership Product is already in the cart");
//         window.location.href = "/cart";
//       } catch (error) {
//         console.error("Error removing item from cart:", error);
//       }
//     } else {
//       const formData = {
//         items: [
//           {
//             id: +id, // Ensure `id` is a number
//             quantity: 1,
//             properties: { _type: "hide" },
//           },
//         ],
//       };

//       try {
//         const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         });

//         if (!response.ok) throw new Error("Failed to add item to cart");

//         const data = await response.json();
//         window.location.href = "/cart";
//       } catch (error) {
//         console.error("Error adding item to cart:", error);
//         e.target.textContent = "Error, try again";
//       }
//     }
//   }

//   function openSSOPopup(path) {
//     const currentUrl = window.location.href;
//         const safeBase64Url = btoa(currentUrl);

//     const client = getCLient();
//     // Calculate dimensions based on screen size
//     const width = Math.min(window.innerWidth * 0.9, 600); // Max width 600px for desktop
//     const height = Math.min(window.innerHeight * 0.9, 700); // Max height 700px for desktop

//     // Center the popup on the screen
//     const left = (window.innerWidth - width) / 2;
//     const top = (window.innerHeight - height) / 2;
//     console.log(`${SSU_URL}/popup/${path}?client=${client}&return_to=${safeBase64Url}&parentOrigin=${encodeURIComponent(window.location.origin)}`)
//     const popup = window.open(
//       `${SSU_URL}/popup/${path}?client=${client}&return_to=${safeBase64Url}&parentOrigin=${encodeURIComponent(window.location.origin)}`, // Replace with your SSO URL
//       "SSO_Login",
//       `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
//     );

//     window.addEventListener("message", async function (event) {
//       const eventData = event.data;
//       const { action, data } = eventData;

//       if (eventData) {
//         switch (action) {
//           case EVENT_ACTIONS.CLOSE_WINDOW:
//             popup.close();
//             break;

//           case EVENT_ACTIONS.REDIRECT_SUCCESS:
//             popup.close();
//             window.location.replace(data.redirect_link);
//             console.log(redirect_link)
//             break;

//           case EVENT_ACTIONS.ELITE_REGISTER_SUCCESS:
//             await addEliteProductToCart();
//             popup.close();
//             window.location.replace(data.redirect_link);
//             console.log(redirect_link)

//             break;

//           case EVENT_ACTIONS.ELITE_UPGRADE:
//             await addEliteProductToCart();
//             popup.close();
//             break;

//           default:
//             console.log("Invalid Action type", action);
//             break;
//         }
//       }
//     });
//   }
